// extracted by mini-css-extract-plugin
module.exports = {"date_wrapper":"date_wrapper--LsBug","breadcrumb":"breadcrumb--2XoY6","select_attribute":"select_attribute--1sVFb","cardCustom":"cardCustom--qi1d6","cardText":"cardText--29388"};